import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { DatePicker } from "antd";
import AppContext from "../../../../AppContext";
import { OrganizeBtnMenu } from "../../../common/mainApp/mainWindowHeaders/MainWindowHeader";

// #region SCOPED CSS
const StyledPage = styled.div`
    &.frame-313325,
    &.frame-313325 * {
        box-sizing: border-box;
    }
    &.frame-313325 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        //height: 68px;
        padding: 15px 24px;
    }
    .frame-313320 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 235px;
        height: 37px;
        position: relative;
        align-self: start;
    }
    .frame-313320.active:not(.disabled) {
        border: 1px solid #0060cc !important;
    }
    .frame-313320.disabled {
        //opacity: 0.5;
        cursor: not-allowed !important;
    }
    .frame-313320.disabled * {
        cursor: not-allowed !important;
    }
    .frame-313320.disabled i,
    .frame-313320.disabled .select-custom-period {
        color: var(--text-icons-gray-300, #4f5b6d);
    }

    .frame-313320:not(.disabled) > *,
    .frame-313320:not(.disabled) .select-custom-period,
    .frame-313320:not(.disabled) .ant-picker-input input {
        cursor: pointer !important;
    }

    .calendar {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .select-custom-period {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        font-style: italic;
        position: relative;
        width: 185px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        line-height: normal;
    }
    .chevron-down {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
        font-size: 10px;
    }
    .calendar {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
        font-size: 12px;
    }
    ._26-january-2024-2-february-2024 {
        color: #ffffff;
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 14px;
    }
    .frame-313322 {
        background: var(--Buttons-All-Platforms-Gray-300, #1e2631);
        border-radius: 5px;
        padding: 0px 8px 0px 8px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
        border: 1px solid transparent;
        height: 30px;
    }
    .frame-313322.active {
        border-radius: 5px;
        border: 1px solid var(--text-icons-green-500, #0b0);
        background: var(--Buttons-All-Platforms-Gray-300, #1e2631);
        color: #fff;
    }
    .frame-313322.active .this-week {
        color: #fff;
    }
    .frame-313322.disabled {
        cursor: not-allowed;
        //opacity: 0.5;
    }
    .frame-313322.disabled .this-week {
        color: var(--text-icons-gray-300, #4f5b6d);
    }

    .frame-313278 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .this-week {
        color: var(--text-icons-gray-100, #d1d1d1);
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: left;
        position: relative;
    }

    .range-picker-pop-up {
        z-index: 1000;
    }

    .range-dropdown-container {
        position: relative;
        z-index: 1000;
    }

    .range-dropdown {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        //right: 0;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: var(--backgrounds-lines-n-500, #141922);
        border-radius: 4px;
        padding: 8px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        min-width: 245px;
        min-height: 50px;
    }
`;

// #endregion

const rangePresets = [
    {
        label: "Max",
        responsiveLabel: "Max",
        value: [moment("2000-01-01"), moment()]
    },
    {
        responsiveLabel: "45d",
        label: "45 days",
        value: [moment().subtract(45, "days"), moment().subtract(1, "days")] //excludes today
    },
    {
        responsiveLabel: "TW",
        label: "This Week",
        value: [moment().startOf("week").day(1), moment()]
    },
    {
        responsiveLabel: "LW",
        label: "Last Week",
        value: [moment().subtract(1, "week").startOf("week").day(1), moment().subtract(1, "week").endOf("week").day(7)]
    },
    {
        responsiveLabel: "TM",
        label: "This Month",
        value: [moment().startOf("month"), moment()]
    },
    {
        responsiveLabel: "LM",
        label: "Last Month",
        value: [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
    },
    {
        responsiveLabel: "TY",
        label: "This Year",
        value: [moment().startOf("year"), moment()]
    },
    {
        responsiveLabel: "LY",
        label: "Last Year",
        value: [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")]
    }
];
export default forwardRef(function KpiMainWindowHeader(props, ref) {
    // #region PROPS
    const { datePeriod, setDatePeriod, enabled, dataAsOfDateTime } = props;
    const dateFormat = "YYYY-MM-DD";

    const {
        isMaxDate = true,
        fromDate = "", //Format is "YYYY-MM-DD", example: "2025-12-01"
        toDate = "", //Format is "YYYY-MM-DD", example: "2025-12-31"
        // eslint-disable-next-line no-unused-vars
        isManualDate = false,
        // eslint-disable-next-line no-unused-vars
        label = "Max"
    } = datePeriod;

    const isCalendarDisabled = !enabled;
    // #endregion

    // #region STATES
    const { aiChatSidePanelOpen } = useContext(AppContext);

    const [selectedRangePreset, setSelectedRangePreset] = useState("Max");
    const [isResponsive, setIsResponsive] = useState(false);
    const [rangeIsDropdown, setRangeIsDropdown] = useState(false);
    const [showRangeDropdown, setShowRangeDropdown] = useState(false);

    const formattedFirstDate = moment(fromDate).format(dateFormat);
    const formattedSecondDate = moment(toDate).format(dateFormat);
    // #endregion

    // #region METHODS
    const onPresetChange = preset => {
        const labelName = preset.label;

        if (labelName === "Max") {
            const newDatePeriod = {
                isMaxDate: true,
                fromDate: "",
                toDate: "",
                isManualDate: false,
                label: "Max"
            };
            setDatePeriod(newDatePeriod);

            setSelectedRangePreset("Max");
            return;
        }

        setSelectedRangePreset(preset.label);

        const newFromDate = moment(preset.value[0]).format(dateFormat);
        const newToDate = moment(preset.value[1]).format(dateFormat);

        const newDatePeriod = {
            isMaxDate: false,
            fromDate: newFromDate,
            toDate: newToDate,
            isManualDate: false,
            label: preset.label
        };
        setDatePeriod(newDatePeriod);
    };

    const onRangeChangeDatePicker = (dates, dateStrings) => {
        const newFromDate = dateStrings[0];
        const newToDate = dateStrings[1];

        if (!newFromDate || newFromDate?.length === 0 || !newToDate || newToDate?.length === 0) return;

        const newDatePeriod = {
            isMaxDate: false,
            fromDate: newFromDate,
            toDate: newToDate,
            isManualDate: true,
            label: "Custom"
        };
        setDatePeriod(newDatePeriod);
        setSelectedRangePreset("Custom");
    };

    const handleCheckResponsive = currentWindowWidth => {
        let minWidth = 1725;
        const sidePanelWidth = 359;

        //if sidepanel is open, we need to add the sidepanel width to the minWidth
        if (aiChatSidePanelOpen) {
            minWidth += sidePanelWidth;

            if (currentWindowWidth < 1820) setRangeIsDropdown(true);
            else setRangeIsDropdown(false);
        }
        setIsResponsive(currentWindowWidth < minWidth);
    };
    // #endregion

    // #region MEMOS
    const getDisabledDate = useCallback(
        current => {
            const maxDate = dataAsOfDateTime ? moment(dataAsOfDateTime, "DD/MM/YYYY") : moment();
            return current && current > maxDate;
        },
        [dataAsOfDateTime]
    );
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (!aiChatSidePanelOpen) setRangeIsDropdown(false);

        const handleResize = () => handleCheckResponsive(window.innerWidth);
        handleResize();

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [aiChatSidePanelOpen]);

    useEffect(() => {
        const handleClickOutside = event => {
            if (!event.target.closest(".range-dropdown-container")) setShowRangeDropdown(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleResetView = () => {
        const newPreset = {
            label: "Max",
            responsiveLabel: "Max",
            value: [moment("2000-01-01"), moment()]
        };

        onPresetChange(newPreset);
        setSelectedRangePreset("Max");
    };
    // #endregion

    // #region RENDER
    useImperativeHandle(ref, () => ({
        resetView: handleResetView
    }));

    return (
        <StyledPage className="frame-313325">
            <div
                className={`frame-313320 ${isCalendarDisabled ? "disabled" : ""} ${
                    datePeriod?.isManualDate && enabled ? "active" : ""
                }`}>
                <DatePicker.RangePicker
                    onChange={onRangeChangeDatePicker}
                    //presets={rangePresets}
                    popupStyle={{
                        position: "absolute",
                        left: "280px"
                    }}
                    style={{
                        opacity: "0",
                        position: "absolute",
                        zIndex: "1000"
                    }}
                    popupClassName={`range-picker-pop-up ${isCalendarDisabled ? "d-none" : ""}`}
                    disabledDate={getDisabledDate}
                />
                <i className="fa-light fa-calendar calendar"></i>
                <div className="select-custom-period">
                    {!isMaxDate ? `${formattedFirstDate} - ${formattedSecondDate}` : "Select custom period"}
                </div>
                <i className="fa-light fa-chevron-down chevron-down"></i>
            </div>

            <div
                style={{
                    display: "flex",
                    gap: "6px",
                    flexWrap: "wrap",
                    alignSelf: "start",
                    marginTop: "3px"
                }}>
                {!rangeIsDropdown &&
                    rangePresets.map(preset => (
                        <DatePresetButton
                            key={preset.label}
                            isActive={
                                !enabled
                                    ? false
                                    : preset.label === "Max"
                                      ? isMaxDate
                                      : preset.label === selectedRangePreset
                            }
                            preset={preset}
                            onClick={onPresetChange}
                            disabled={isCalendarDisabled ? preset.label !== "Max" || !enabled : false}
                            isResponsive={isResponsive}
                            selectedBorderColor={preset.label === "Max" ? "#00bb00" : "#0060cc"}
                        />
                    ))}

                {rangeIsDropdown && (
                    <div className="range-dropdown-container">
                        <DatePresetButton
                            key="rangeIsDropdown"
                            isActive={!datePeriod?.isManualDate && enabled}
                            preset={
                                datePeriod?.isManualDate || !datePeriod?.label
                                    ? {
                                          label: "Max",
                                          value: [moment("2000-01-01"), moment()]
                                      }
                                    : {
                                          label: datePeriod?.label,
                                          value: [moment(datePeriod.fromDate), moment(datePeriod.toDate)]
                                      }
                            }
                            onClick={() => setShowRangeDropdown(true)}
                            disabled={isCalendarDisabled}
                            isResponsive={false}
                            selectedBorderColor={datePeriod?.isMaxDate ? "#00bb00" : "#0060cc"}
                            showChevronDown={true}
                        />

                        <div className={`range-dropdown ${showRangeDropdown ? "open" : "d-none"}`}>
                            <OrganizeBtnMenu
                                items={rangePresets.map(preset => ({
                                    name: preset.label,
                                    value: preset.label
                                }))}
                                onItemClick={value => {
                                    const presetClicked = rangePresets.find(preset => preset.label === value);
                                    onPresetChange(presetClicked);
                                    setShowRangeDropdown(false);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        </StyledPage>
    );
    // #endregion
});

// #region COMPONENTS
const DatePresetButton = ({
    isActive,
    preset,
    onClick,
    disabled = false,
    isResponsive = false,
    selectedBorderColor,
    showChevronDown = false
}) => {
    const onButtonClick = () => {
        if (!onClick || disabled) return;
        onClick(preset);
    };

    return (
        <div
            className={`frame-313322 ${isActive ? "active" : ""} ${disabled ? "disabled" : ""}`}
            onClick={onButtonClick}
            //change border color only if is active
            style={{
                borderColor: isActive ? selectedBorderColor : ""
            }}>
            <div className="frame-313278">
                <div className="frame-160">
                    <div className="this-week">{isResponsive ? preset.responsiveLabel : preset.label}</div>
                </div>
                {showChevronDown && (
                    <i
                        className={`fa-light fa-chevron-down chevron-down ${
                            !disabled ? "text-white" : "text-inactive"
                        }`}></i>
                )}
            </div>
        </div>
    );
};
// #endregion
